<template>
  <div class="p-8" :style='"padding-bottom: 0;color:"+data.style.color'>
    <div class="bor-rad-5 s_over_h" :style="'background: linear-gradient(90deg, '+data.style.bgColor.left+' 0%, '+data.style.bgColor.right+' 100%);'">
      <p class="p-l-8 p-t-8 fz-15 s_font_b" v-if='data.style.show'>{{data.style.moduleTitle}}</p>
      <div class="s_flex_wrap s_flex_ali p-t-15">
        <template v-for="(item,index) in data.data" :key="index">
          <div class="width33 m-b-15" v-show='item.show'>
            <img class="width-40 height-40 s_mauto ds-b" style="width:40px" :src="item.imgUrl?info.picdomain+item.imgUrl:require('@/assets/images/user/mo'+index+'.png')" alt="">
            <p class="fz-13 text-ac m-t-6">{{item.name || '功能名称'}}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
  
</template>
<script>
  import { ref} from "vue";
  import store from "@/store";
  // import { RightOutlined } from "@ant-design/icons-vue";
  export default {
    components: {},
    props: { data: Object },
    name: "module",
    setup(){
      return{
        info: ref(store.state.user.info)
      }
    }
  };
</script>
<style>

</style>